import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

import { ApiService } from "./api.service";

import { IHttpResponse } from "@schema/http";
import { environment as env } from "@env";

@Injectable({
  providedIn: "root"
})
export class PermissionService {

  /**
   * A cached list of permissions available for the given property
   */
  protected _permissions: string[] = [];

  constructor(
    protected _apiService: ApiService,
  ) { }

  /**
   * Check if the user DOES have permission for the given action
   *
   * @param permission  The permission ID/name
   * @param global      If we should check in the global namespace or just Empirica
   */
  public can(permission: string, global: boolean = false): boolean {
    if (!permission) { return false; }
    const namespace = global ? "Global" : "Empirica";
    return this._permissions.some((allowedPermission: string) => {
      return allowedPermission.indexOf(`Innovian.${namespace}/${permission}`) === 0;
    });
  }

  /**
   * Check if the user does NOT have permission for the given action
   *
   * @param permission  The permission ID/name
   * @param global      If we should check in the global namespace or just Empirica
   */
  public cannot(permission: string, global: boolean = false): boolean {
    return !this.can(permission, global);
  }

  /**
   * Load the permissions for the given property
   *
   * @param propertyId  The property's ID
   */
  public load(propertyId: string): ReplaySubject<boolean> {
    const loaded: ReplaySubject<boolean> = new ReplaySubject(1);
    loaded.next(false);
    this._apiService.get(
      `${env.api.globalHost}/2019-03-01/me/permissions/${propertyId}`
    ).subscribe((response: IHttpResponse<string[]>) => {
      this._permissions = response.data;
      loaded.next(true);
      loaded.complete();
    });
    return loaded;
  }
}
